/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubMenu } from '../../models/sub-menu';

export interface ApiMasterSubMenuGetActiveGet$Params {
}

export function apiMasterSubMenuGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterSubMenuGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubMenu>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterSubMenuGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubMenu>>;
    })
  );
}

apiMasterSubMenuGetActiveGet.PATH = '/api/Master/SubMenu/GetActive';
